import { Box, OsModal } from "@outschool/backpack";
import { IconDefinition } from "@outschool/icons";
import { useTranslation } from "@outschool/localization";
import React from "react";

import { SearchInputField } from "./SearchInputField";

export function SearchInputModal(props: {
  children: React.ReactNode;
  filterIcon?: IconDefinition;
  filterDisplayValue?: string;
  filterPlaceholder?: string;
  filterValue?: string;
  onClose: () => void;
  onOpen: () => void;
  open: boolean;
}) {
  const {
    children,
    filterIcon,
    filterDisplayValue,
    filterPlaceholder,
    filterValue,
    onClose,
    open,
  } = props;

  const { t } = useTranslation(
    "client\\components\\search\\mobile\\SearchInputModal",
  );

  const onClick = () => {
    const { open, onClose, onOpen } = props;
    if (open) {
      onClose();
    } else {
      onOpen();
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
      }}
    >
      <SearchInputField
        icon={filterIcon}
        placeholder={filterPlaceholder}
        value={!!filterDisplayValue ? filterDisplayValue : filterValue}
        onClick={onClick}
      />
      {open && (
        <SearchInputModalOverlay onClose={onClose} title={t("Filters")}>
          {children}
        </SearchInputModalOverlay>
      )}
    </Box>
  );
}

export function SearchInputModalOverlay({
  children,
  onClose = () => {},
  title,
}: {
  children: React.ReactNode;
  onClose?: () => void;
  title?: string;
}) {
  return (
    <OsModal open={true} onClose={onClose} title={title}>
      <Box
        sx={{
          padding: "1em 1em 100px 1em",
        }}
      >
        {children}
      </Box>
    </OsModal>
  );
}
